import * as React from 'react';
import { ActionButton, Title, LoadingShimmer } from '@icarros/ids-react';
import { useHistory } from 'react-router-dom';
import { ResumeHeader } from './style';
import { useAdContext } from '../../../store/contexts/ad';

export function Header(): JSX.Element {
  const history = useHistory();
  const { currentAd } = useAdContext();

  return (
    <ResumeHeader>
      <ActionButton
        variant="neutral"
        weight="small"
        text="voltar"
        iconName="itaufonts_seta"
        onClick={() => history.push('/meus-anuncios')}
      />
      <LoadingShimmer show={!currentAd}>
        <Title contrast="light">detalhes do anúncio</Title>
      </LoadingShimmer>
    </ResumeHeader>
  );
}
